import React, { useState } from 'react'
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';
import ProductIssueListView from '../../../components/inventory/reports/product_issue/ProductIssueListReportView';

const InventoryIssueReturnReportListView = () => {

    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/transaction/issue/report/list/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <ProductIssueListView setOnURL={setOnURL} handleFormSuccess={handleFormSuccess} data={data} loading={loading} error={error} />
    )
}

export default InventoryIssueReturnReportListView